// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./files/BlenderProMedium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./files/BlenderProBold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: 'Blender Pro';
    font-style: normal;
    font-display: swap;
    font-weight: 200;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype'), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
}

@font-face {
    font-family: 'Blender Pro';
    font-style: normal;
    font-display: swap;
    font-weight: 300;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype'), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
}

@font-face {
    font-family: 'Blender Pro';
    font-style: normal;
    font-display: swap;
    font-weight: 400;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype'), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
}

@font-face {
    font-family: 'Blender Pro';
    font-style: normal;
    font-display: swap;
    font-weight: 600;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype'), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
}

@font-face {
    font-family: 'Blender Pro';
    font-style: normal;
    font-display: swap;
    font-weight: 700;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype'), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
}

@font-face {
    font-family: 'Blender Pro';
    font-style: normal;
    font-display: swap;
    font-weight: 900;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype'), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
}
`, "",{"version":3,"sources":["webpack://./src/assets/fonts/blenderPro/index.css"],"names":[],"mappings":"AAAA;IACI,0BAA0B;IAC1B,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,2HAA6G;AACjH;;AAEA;IACI,0BAA0B;IAC1B,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,2HAA6G;AACjH;;AAEA;IACI,0BAA0B;IAC1B,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,2HAA2G;AAC/G;;AAEA;IACI,0BAA0B;IAC1B,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,2HAA2G;AAC/G;;AAEA;IACI,0BAA0B;IAC1B,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,2HAA2G;AAC/G;;AAEA;IACI,0BAA0B;IAC1B,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,2HAA2G;AAC/G","sourcesContent":["@font-face {\n    font-family: 'Blender Pro';\n    font-style: normal;\n    font-display: swap;\n    font-weight: 200;\n    src: url(./files/BlenderProMedium.ttf) format('truetype'), url(./files/BlenderProBold.ttf) format('truetype');\n}\n\n@font-face {\n    font-family: 'Blender Pro';\n    font-style: normal;\n    font-display: swap;\n    font-weight: 300;\n    src: url(./files/BlenderProMedium.ttf) format('truetype'), url(./files/BlenderProBold.ttf) format('truetype');\n}\n\n@font-face {\n    font-family: 'Blender Pro';\n    font-style: normal;\n    font-display: swap;\n    font-weight: 400;\n    src: url(./files/BlenderProBold.ttf) format('truetype'), url(./files/BlenderProBold.ttf) format('truetype');\n}\n\n@font-face {\n    font-family: 'Blender Pro';\n    font-style: normal;\n    font-display: swap;\n    font-weight: 600;\n    src: url(./files/BlenderProBold.ttf) format('truetype'), url(./files/BlenderProBold.ttf) format('truetype');\n}\n\n@font-face {\n    font-family: 'Blender Pro';\n    font-style: normal;\n    font-display: swap;\n    font-weight: 700;\n    src: url(./files/BlenderProBold.ttf) format('truetype'), url(./files/BlenderProBold.ttf) format('truetype');\n}\n\n@font-face {\n    font-family: 'Blender Pro';\n    font-style: normal;\n    font-display: swap;\n    font-weight: 900;\n    src: url(./files/BlenderProBold.ttf) format('truetype'), url(./files/BlenderProBold.ttf) format('truetype');\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
